import gql from 'graphql-tag';
import { clients } from '../../util/clients';
import { fieldsToGqlString } from '../../util/shared/vue-global';

const { backend } = clients.direct;

const defaultFileQueueFields = {
  _id: '',
  timestamp: '',
  FileName: '',
  FilePath: '',
  Program: '',
  FileDefinitionId: '',
  FileDefinitionName: '',
  Status: '',
  Records: '',
  TotalRecords: '',
  Errors: '',
  Parameters: '',
  ErrorDetail: {
    LineNumber: '',
    ErrorDescription: '',
  },
};

export const FileQueueActions = {
  async loadFileQueues({ commit, dispatch }, { criteria, fields }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      const gqlfields = fields || defaultFileQueueFields;

      results = await backend.query({
        query: gql`query fileQueues($criteria: fileQueueCriteriaType) {
          fileQueues(criteria: $criteria) {
            ${fieldsToGqlString(gqlfields)}
          }
        }`,
        variables: { criteria },
        fetchPolicy: 'no-cache',
      });

      clients.handleGQLErrors(results, commit);
      const { fileQueues } = results.data;
      return fileQueues || [];
    } catch (e) {
      dispatch('logException', e, { root: true });
      clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem loading file queue entries.', { root: true });
      return [];
    }
  },

  async loadFileQueue({ commit, dispatch }, { _id, fields }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      const gqlfields = fields || defaultFileQueueFields;

      results = await backend.query({
        query: gql`query fileQueue($_id: ID!) {
          fileQueue(_id: $_id) {
            ${fieldsToGqlString(gqlfields)}
          }
        }`,
        variables: { _id },
        fetchPolicy: 'no-cache',
      });

      clients.handleGQLErrors(results, commit);
      const { fileQueue } = results.data;
      return fileQueue;
    } catch (e) {
      dispatch('logException', e, { root: true });
      clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem loading the file queue entry.', { root: true });
      return null;
    }
  },

  async upsertFileQueue({ commit, dispatch }, { item, fields }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      const gqlfields = fields || defaultFileQueueFields;

      // Convert Parameters object to JSON string if it's an object
      const upsertItem = { ...item };
      if (upsertItem.Parameters && typeof upsertItem.Parameters === 'object') {
        upsertItem.Parameters = JSON.stringify(upsertItem.Parameters);
      }

      results = await backend.mutate({
        mutation: gql`mutation upsertFileQueue($item: fileQueueInputType) {
          upsertFileQueue(upsert: $item) {
            ${fieldsToGqlString(gqlfields)}
          }
        }`,
        variables: { item: upsertItem },
      });

      clients.handleGQLErrors(results, commit);
      const { upsertFileQueue } = results.data;
      return upsertFileQueue;
    } catch (e) {
      dispatch('logException', e, { root: true });
      clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem saving the file queue entry.', { root: true });
      return null;
    }
  },

  async deleteFileQueue({ commit, dispatch }, { _id }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });

      results = await backend.mutate({
        mutation: gql`mutation deleteFileQueue($_id: ID!) {
          deleteFileQueue(_id: $_id) {
            _id
          }
        }`,
        variables: { _id },
      });

      clients.handleGQLErrors(results, commit);
      const { deleteFileQueue } = results.data;
      return deleteFileQueue;
    } catch (e) {
      dispatch('logException', e, { root: true });
      clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem deleting the file queue entry.', { root: true });
      return null;
    }
  },
};

export default FileQueueActions;
